import { useCallback, useState, useEffect } from "react";
import BraftEditor from "braft-editor";
import "braft-editor/dist/index.css";

function ContentEditor({ value, onChange }) {
  const [content, setContent] = useState(BraftEditor.createEditorState(null));
  useEffect(() => {
    setContent(BraftEditor.createEditorState(value));
  }, [setContent, value]);
  const changeHandler = useCallback(
    (editorState) => {
      setContent(editorState);
    },
    [setContent]
  );
  const blurHandler = useCallback(() => {
    onChange(content.toHTML());
  }, [onChange, content]);

  return (
    <div className="content-editor">
      <BraftEditor
        controls={[
          "undo",
          "redo",
          "font-size",
          "font-family",
          "line-height",
          "letter-spacing",
          "text-color",
          "bold",
          "italic",
          "underline",
          "strike-through",
          "remove-styles",
        ]}
        fontFamilies={[
          {
            name: "宋体",
            family: "SimSun",
          },
          {
            name: "黑体",
            family: "SimHei",
          },
          {
            name: "微软雅黑",
            family: "Microsoft Yahei",
          },
          {
            name: "微软正黑体",
            family: "Microsoft JhengHei",
          },
          {
            name: "楷体",
            family: "KaiTi",
          },
          {
            name: "新宋体",
            family: "NSimSun",
          },
          {
            name: "仿宋",
            family: "FangSong",
          },
        ]}
        value={content}
        onChange={changeHandler}
        onBlur={blurHandler}
      />
    </div>
  );
}

export default ContentEditor;
